export const provider = ['quiknode','firebaseapp.com', 'firebasestorage']